<style scoped>
    .label {
        font-weight: 600;
    }
    .separador-gris { 
        border: 0;
        height: 1px;
        background: #ccc;
        margin: 20px 0;
        width: 100%; 
    }
    .box {
        background-color: #6985f5; /* Color gris */
        color: white;
        padding: 10px;
        border-radius: 15px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        text-align: center;
        max-width: 400px;
        margin: 0 auto;
    }
    .title {
        font-size: 18px;
        font-weight: bold;
        margin: 0;
    }
    .info-box {
        height: 100px; /* Fija la altura */
        overflow: auto; /* Permite el scroll si el contenido excede la altura */
        white-space: pre-line; /* Para manejar los saltos de línea de manera adecuada */
        padding: 15px; /* Espacio interno más generoso */
        border: 1px solid #ddd; /* Borde más sutil */
        border-radius: 8px; /* Bordes redondeados */
        font-size: 14px; /* Tamaño de fuente */
        line-height: 1.6; /* Mayor espaciado entre líneas para mejorar la legibilidad */
        background-color: #f4f6f9; /* Color de fondo más suave */
        width: 100%; /* Ajusta el ancho */
        box-sizing: border-box; /* Padding no afecta el tamaño total */
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Sombra suave para darle profundidad */
        color: #333; /* Color del texto */
    }
    .info-box:focus {
        outline: none; /* Quita el borde predeterminado del input al enfocarse */
        border-color: #a0d1fb; /* Color de borde más vibrante al enfocarse */
        box-shadow: 0 0 6px rgba(32, 150, 243, 0.5); /* Sombra más vibrante al enfocarse */
    }
</style>
<template>
    <div class="">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body" style="margin-top: -4%;">
            <form ref="form" data-url="/crud" :class="{ 'loading-opacity': preloader }">
                <div class="form-group card-with-shadow p-2 mt-3">
                    <div class="box mt-3 mb-3">
                        <h1 class="title">{{ $t("product") }}</h1>
                    </div>
                    <div v-if="products" class="row" v-for="(p, index) in products" :key="index">
                        <div class="form-group col-md-3">
                            <label for="product" class="label"> {{ $t("product") }}</label>
                            <app-input type="text" v-model="p.name" disabled="disabled" />
                        </div>
                        
                        <div class="form-group col-md-6">
                            <label for="description" class="label"> {{ $t("description") }}</label>
                            <app-input type="text" v-model="p.description" disabled="disabled" />
                        </div>
                        
                        <div class="form-group col-md-3">
                            <label for="origin" class="label"> {{ $t("origin") }}</label>
                            <app-input type="text" v-model="p.countryOrigin" disabled="disabled" />
                        </div>
                        
                        <div class="form-group col-md-3">
                            <label for="quantity" class="label"> {{ $t("quantity") }}</label>
                            <app-input type="text" v-model="p.quantity" disabled="disabled" />
                        </div>
                        
                        <div class="form-group col-md-3">
                            <label for="pack" class="label"> {{ $t("pack") }}</label>
                            <app-input type="text" v-model="p.pack" disabled="disabled" />
                        </div>
                        
                        <div class="form-group col-md-3">
                            <label for="net_weight" class="label"> {{ $t("net_weight") }}</label>
                            <app-input type="text" v-model="p.net_weight" disabled="disabled" />
                        </div> 
                      
                        <div class="form-group col-md-3">
                            <label for="load_method" class="label"> {{ $t("load_method") }}</label>
                            <app-input type="text" v-model="p.load_method" disabled="disabled" />
                        </div>
                        
                        <div class="form-group col-md-3">
                            <label for="packer" class="label"> {{ $t("packer") }}</label>
                            <app-input type="text" v-model="supplier.packer" disabled="disabled" />
                        </div> 

                        <div class="form-group col-md-3">
                            <label for="supplier_price" class="label"> {{ $t('supplier_price') }} </label>
                            <app-input type="text" v-model="p.supplier_price" disabled="disabled" />
                        </div>

                        <div class="form-group col-md-3">
                            <label for="customer_price" class="label"> {{ $t('customer_price') }} </label>
                            <app-input type="text" v-model="p.customer_price" disabled="disabled" />
                        </div>
                        
                        <hr v-if="index < products.length - 1" class="separador-gris">
                        
                    </div> 
                    <hr class="separador-gris">
                    <div class="box mt-3 mb-3">
                        <h1 class="title">{{ $t("supplier") }}</h1>
                    </div>
                    <div class="row" v-if="supplier">
                        <div class="form-group col-md-3">
                            <label for="suppliier" class="label"> {{ $t("supplier") }}</label>
                            <app-input type="text" v-model="supplier.name" disabled="disabled" />
                        </div>

                        <div class="form-group col-md-3">
                            <label for="incoterm" class="label"> {{ $t("incoterm") }}</label>
                            <app-input type="text" v-model="supplier.incoterm" disabled="disabled" />
                        </div>
                        <div class="form-group col-md-3">
                            <label for="payment_term" class="label"> {{ $t("payment_term") }}</label>
                            <app-input type="text" v-model="supplier.payment_term" disabled="disabled" />
                        </div>
                    </div>
                    <hr class="separador-gris">
                    <div class="box mt-3 mb-3">
                        <h1 class="title">{{ $t("customer") }}</h1>
                    </div>
                    <div class="row" v-if="customer && customerAddrress">
                        <div class="form-group col-md-3">
                            <label for="customer" class="label"> {{ $t("customer") }}</label>
                            <app-input type="text" v-model="customer.name" disabled="disabled" />
                        </div>
                        <div v-for="addr in customerAddrress" :key="addr.id" class="form-group col-md-3">
                            <label for="customerAddress" class="label"> {{ $t('address')  }} </label>
                            <div class="info-box"> {{ getFormattedAddress(addr) }}</div>
                        </div>

                        <div class="form-group col-md-3">
                            <label for="customer" class="label"> {{ $t("term") }}</label>
                            <app-input type="text" v-model="customer.incoterm" disabled="disabled" />
                        </div>
                        <div class="form-group col-md-3">
                            <label for="customer" class="label"> {{ $t("payment_term") }}</label>
                            <app-input type="text" v-model="customer.term" disabled="disabled" />
                        </div>
                    </div>
                    <hr class="separador-gris">

                    <div class="box mt-3 mb-3">
                        <h1 class="title">{{ $t("logistics_customs_reference_information") }}</h1>
                    </div>
                    <div class="row" v-if="detail">
                        <div class="form-group col-md-3">
                            <label for="total_loads" class="label"> {{ $t("total_loads") }}</label>
                            <app-input type="text" v-model="detail.total_loads" disabled="disabled" />
                        </div>
                        <div class="form-group col-md-3">
                            <label for="total_loads" class="label"> {{ $t("temperature_in_celsius") }}</label>
                            <app-input type="text" v-model="detail.celsius" disabled="disabled" />
                        </div>
                        <div class="form-group col-md-3">
                            <label for="shipment_type" class="label"> {{ $t("shipment_type") }}</label>
                            <app-input type="text" v-model="detail.shipment_type" disabled="disabled" />
                        </div>
                        <div class="form-group col-md-3">
                            <label for="quality_inspection" class="label"> {{ $t("quality_inspection") }}</label>
                            <app-input type="text" v-model="detail.quality_inspection" disabled="disabled" />
                        </div>
                        <div class="form-group col-md-3">
                            <label for="port_of_destination" class="label"> {{ $t("port_of_destination") }}</label>
                            <app-input type="text" v-model="detail.port_of_destination" disabled="disabled" />
                        </div>
                        <div class="form-group col-md-3">
                            <label for="shipment_schedule" class="label"> {{ $t("shipment_schedule") }}</label>
                            <app-input type="text" v-model="detail.shipment_schedule" disabled="disabled" />
                        </div>
                        <div class="form-group col-md-3">
                            <label for="inland_based" class="label"> {{ $t("inland_based") }}</label>
                            <app-input type="text" v-model="detail.inland_based" disabled="disabled" />
                        </div> 
                        <div class="form-group col-md-3">
                            <label for="cv_value_applicable" class="label"> {{ $t("cv_value_applicable") }}</label>
                            <app-input type="text" v-model="detail.cv_value_applicable" disabled="disabled" />
                        </div>  
                        <div class="form-group col-md-3">
                            <label for="tariff" class="label"> {{ $t("tariff") }}</label>
                            <app-input type="text" v-model="detail.tariff" disabled="disabled" />
                        </div>  
                        <div class="form-group col-md-3">
                            <label for="duty_rate" class="label"> {{ $t("duty_rate") }}</label>
                            <app-input type="text" v-model="detail.duty_rate" disabled="disabled" />
                        </div> 
                        <div class="form-group col-md-3">
                            <label for="reciprocal_tariff" class="label"> {{ $t("reciprocal_tariff") }}</label>
                            <app-input type="text" v-model="detail.reciprocal_tariff" disabled="disabled" />
                        </div> 
                    </div>
                </div> 
            </form>
        </div>
    </div>
</template>

<script>

import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import { get_data_products, get_data_contract, get_data_supplier, get_data_customer, get_ship_address_customer } from '../mixins/api.js';

export default {
    name: "contractDetailView",
    mixins: [FormMixin],
    data() {
        return {
            products : [],
            customerAddrress : [],
            masterContract : {},
            contractDetail : {},
            supplier : {},
            customer : {},
            detail : {},
            preloader : false,
            contractId : null,
        }  
    },
    methods: {
        getFormattedAddress(addressObject) {
            const value = addressObject.value ?? '';
            const address = addressObject.address ?? '';
            const country = addressObject.country_name ?? '';
            const state = addressObject.state_name ?? '';
            const city = addressObject.city_name ?? '';
            return `${value} ${address} ${country} ${state} ${city}`;
        },

        async loadContractDetails(id) {
            if (id) {
                const respuesta = await get_data_contract(id);
                if (respuesta) {
                    this.masterContract = respuesta[0];
                    this.contractDetail = respuesta[1];
                    this.mannageContracDetail(respuesta[1]);
                }
            }
        },
        async loadSupplierDetails(id) {
            if (id) {
                const respuesta = await get_data_supplier(id);  
                this.mannageResSupplier(respuesta);
            }
        },
        async loadProductsDetails(id) {
			if (id) {
				const respuesta = await get_data_products(id);	
				if (respuesta) {
					this.mannageResProducts(respuesta);
				}
			} 
		},
        async loadCustomerDetails(id) {
            if (id) {
                const respuesta = await get_data_customer(id);
                if (respuesta) {
                    const {cud_customer} = respuesta;    
                    this.mannageResCustomer( respuesta );
                    await this.loadCustomerAddress(cud_customer);
                }
            }
        },
        async loadCustomerAddress(customer){
            if (customer) {
                this.customerAddrress = await get_ship_address_customer(customer.id); 
            }
        },

        mannageContracDetail( respuesta ) {
            const checks = respuesta.checkbox;
            const quality_inspection = checks.includes("Quality Inspection Required?");  
            const detail = {
                total_loads : respuesta?.loads ?? 0,
                celsius : respuesta?.tem_celsius ?? '',
                shipment_type : respuesta?.shipment_type?.value ?? null,
                quality_inspection : quality_inspection ? 'Yes' : 'No',
                port_of_destination : '',
                shipment_schedule   : '',
                ocean_based_rate    : '',
                inland_based        : '',
                cv_value_applicable : '',
                tariff              : '',  
                duty_rate           : '',   
                reciprocal_tariff   : '',
            }
            this.detail = detail;
        },
        
        mannageResCustomer ( respuesta ){
            const customer = {
                name : respuesta?.cud_customer?.titulo ?? '',
                term : respuesta?.cud_pay_term?.value ?? '',
                incoterm : respuesta?.cud_incoterm?.value ?? '',
            }   
            this.customer = customer;
        },

        mannageResSupplier (respuesta){
            const supplier = {
                name : respuesta?.sd_supplier?.titulo ?? '',
                incoterm : respuesta?.sd_incoterm?.value ?? '',
                packer : respuesta?.sd_packer?.value ?? '',
                payment_term : respuesta?.sd_payment_term?.value ?? '',
            };
            this.supplier = supplier;
        },

        mannageResProducts(respuesta){
            const products = [];
            for (const key in respuesta) {
                let product = {};
                const p = respuesta[key];  
                product = {
                    pContractId : p?.pd_contrac_product_id ?? '',
                    name : p?.pd_product?.name ?? '',
                    description : `(${p?.pd_typedata?.value}) ${p?.pd_subCategory?.value ?? ''} ${p?.pd_product?.name ?? ''} ${p?.pd_feature?.value ?? ''} ${p?.pd_cut_size?.value ?? ''} ${p?.pd_grade?.value ?? ''} ${p?.pd_crop?.value ?? ''}` ,
                    countryOrigin  : this?.masterContract?.country?.name ?? '',
                    quantity : `${p?.pd_quantity ?? ''} `,
                    pack : `${p?.pd_pack.value ?? ''}`,
                    net_weight : `${p?.pd_weight ?? ''} ${p?.pd_net.value ?? ''}`,
                    load_method : this?.contractDetail?.load_method?.value ?? '',
                    supplier_price: `${p?.pd_supplierCurrency?.Code ?? '' }  ${p?.pd_suplierPrice ?? 0}`,
                    customer_price: `${p?.pd_customerCurrency?.Code ?? '' }  ${p?.pd_customerPrice ?? 0}`
                }
                products.push(product);
            }
            this.products = products;  
        },
    },

    async mounted() { 
        if (this.$route.params.id) {
            this.contractId = this.$route.params.id;
            localStorage.setItem('contractDetailId', this.$route.params.id);
        }else if (localStorage.getItem('contractDetailId')) {
            this.contractId = localStorage.getItem('contractDetailId');
        }
        if (this.contractId) {
            this.preloader = true;
            await this.loadContractDetails(this.contractId);
            await this.loadProductsDetails(this.contractId);
            await this.loadSupplierDetails(this.contractId); 
            await this.loadCustomerDetails(this.contractId);  
            this.preloader = false;
        }
    },
}
</script>
